import Local from '@/common/util/local.js';
import { toMap } from '@dsee/util/arrays.js';

export const SUBSCRIPTION_CONFIG_KEY = 'SUBSCRIPTION_CONFIG';

export const DICT_SUBSCRIPTIONS = [
    { id: 'DAILY', name: 'В день изменений' },
    { id: 'MONTHLY', name: 'Раз в месяц' },
];

export const dictSubscriptionsMap = toMap(DICT_SUBSCRIPTIONS);

export function currentSubConfig() {
    const { active, period } = Local.get(SUBSCRIPTION_CONFIG_KEY, {});
    return {
        active: active ?? false,
        period: period ?? null,
    };
}
